module.exports = __webpack_public_path__ + "fonts/Roboto-300.d26871e8.woff2";